export default __webpack_public_path__ + "static/media/right-desktop-header-bg.fdd2ad27.svg";